/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Alpine from 'alpinejs';
import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import HeaderMenu from './navigation/header-menu';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import ResponsiveImage from './modules/responsive-image';
import NumberAnimation from './modules/number-animation';
import ChartSlider from './modules/chart-slider';
import HorizontalScrollingText from './modules/horizontal-scrolling-text';
import Rellax from 'rellax';
import * as GLOBALS from "./globals";
import BarChart from './modules/bar-chart';
import BubbleChart from './modules/bubble-chart';
import LineChart from './modules/line-chart';
import HighlightText from './modules/highlight';
import AnimationGrid from './modules/animation-grid';

const siteInitialization = () => {
	CookieByte.init();
	HeaderMenu.init();
	Accordion.initAll();
	MediaViewer.init();
	ImageGallery.initAll();
	Form.init();
	NumberAnimation.init();
	ChartSlider.initAll();
	HorizontalScrollingText.init();
	BarChart.initAll();
	BubbleChart.initAll();
	LineChart.initAll();
	HighlightText.initAll();
	AnimationGrid.initAll();

	// Initialize Parallax scrolling library (not on IE or anything below tablets)
	if (!window.document.documentMode && window.innerWidth > GLOBALS.BREAKPOINT_LG) {
		new Rellax('[data-rellax]');
	}

	ResponsiveImage.initAll();

	window.Alpine = Alpine;	
	Alpine.start();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
